import {Stream} from 'xstream';
import dom from './dom';

const indexOf = Array.prototype.indexOf;
const extend = Object.assign;

/**
 * 创建一个stream和模态框，stream的next和compolele由模态框的交互触发
 * @param  {String}          content    模态框内容
 * @param  {String|Function} okText     确认文本，或按钮的工厂函数
 * @param  {String}          cancelText 取消文本
 * @param  {Object}          config     其他配置，比dialog的配置多以下字段
 * @param  {Boolean}         config.reverse      是否反转按钮的布局
 * @param  {*}               config.cancelValue  关闭模态框是也next值
 * @param  {function}        config.onClose  关闭弹窗回调
 *
 * @syntax
 * Stream.dialog(content, okText, cancelText, config)
 * Stream.dialog(content, factory)
 * Stream.dialog(content, factory, config)
 */
Stream.dialog = function(content, okText, cancelText, config) {
    return Stream.create({
        start(prod) {
            var _dialog, options, _onClose;
            var callbackList = [
                function(value) {prod.next({value, dialog: _dialog})},
                function() {config.hasOwnProperty('cancelValue') ? callbackList[0](config.cancelValue) : prod.complete()}
            ];

            options = {
                content,
                button: typeof okText === 'function' ?
                    okText.apply(null, callbackList) :
                    [okText, cancelText].filter(text => typeof text === 'string').map((text, i) => ({text, callback: callbackList[i], type: i === 1 ? 'cancel' : 'ok'}))
            };

            if (cancelText && typeof cancelText === 'object') {
                config = cancelText;
            }

            _onClose = config && config.onClose;
            config = config || {};

            config = Object.assign(Dialog.defaultConfig, config);
            extend(options, config, {
                onClose() {
                    _onClose ? _onClose(callbackList[0]) : callbackList[1]();
                }
            })
            if (options.reverse) {
                options.button.reverse();
            }

            this.dialog = _dialog = dialog(options);
        },
        stop() {
            this.dialog.del();
        }
    })
}


const tplReg = /<%([\s\S]*?)%>/g;
const btnTpl = '<a href="#" class="js-dialog-btn <%className%>"><%text%></a>';
const dialogTpl = `<div class="cp-dialog-wrap cp-dialog-wrap--close s-tabcell fs-14" style="display: none;">
    <div class="cp-dialog">
        <div class="icon-close-btn js-dialog-close-btn"><i class="icon-close2 d-b"></i></div>
        <div class="cp-dialog__title"><%title%></div>
        <div class="cp-dialog__body"><%content%></div>
        <div class="cp-dialog__footer flex"><%buttons%></div>
    </div>
</div>`;


const btnTplCF = '<a href="#" class="js-dialog-btn js-dialog-btn-cf <%className%>"><%text%></a>';
const dialogTplCF = `<div class="cp-dialog-wrap cp-dialog-wrap--close s-tabcell fs-14" style="display: none;">
    <div class="cp-dialog">
        <div class="icon-close-btn js-dialog-close-btn"><i class="icon-close2 d-b"></i></div>
        <div class="cp-dialog__title"><%title%></div>
        <div class="cp-dialog__body"><%content%></div>
        <div class="cp-dialog__footer_cf"><%buttons%></div>
    </div>
</div>`;


Dialog.setting = {
    classNameSheet: {
        ok: 'cp-btn cp-btn--yellow flex__item',
        cancel: 'cp-btn flex__item'
    }
};

Dialog.setting_cf = {
    classNameSheet: {
        active: 'cp-btn cp-btn--yellow',
        cancel: 'cp-btn',
        common: 'cp-btn btn-common',
        disabled: 'cp-btn disabled'

    }
};

Dialog.defaultConfig = {
    reverse: false
};

function Dialog(options) {
    var self = this;
    var $dialog, buttons =  options.button || [];
    var params = {
        content: options.content || '',
        title: options.title || '',
        buttons: buttons.map(data => btnTpl.replace(tplReg, function(_, field) {
                    var val = data[field];
                    if (!val && !data.isCf && field === 'className') {
                        return Dialog.setting.classNameSheet[data.type || 'ok'];
                    }
                    if (!val && data.isCf && field === 'className') {
                        if (data.active) {
                            return Dialog.setting_cf.classNameSheet['active'];
                        }else if (data.disabled) {
                            return Dialog.setting_cf.classNameSheet['disabled'];
                        }else{
                            return Dialog.setting_cf.classNameSheet['common'];
                        }
                    }

                    return val;
                })).join('')

    };
    if (options.button.length === 3) {
        $dialog = dom.create(dialogTplCF.replace(tplReg, (_, field) => params[field] || ''));
    }else{
        $dialog = dom.create(dialogTpl.replace(tplReg, (_, field) => params[field] || ''));
    }

    if (!options.useCloseBtn) {
        $dialog.classList.add('cp-dialog-wrap--no-close');
    }

    document.body.appendChild($dialog);
    $dialog.addEventListener('click', self._handler = function(e) {
        var node = e.target;
        var $btn = dom.closest(node, '.js-dialog-btn');

        if ($btn) {
            var cb = self.callbackList[indexOf.call($btn.parentNode.children, $btn)];
            e.preventDefault();
            typeof cb === 'string' ? self[cb]() : cb.call(self, 'success');
        } else if (dom.closest(node, '.js-dialog-close-btn')) {
            self.del(true);
        } else if (options.backdropClose && node === this) {
            self.del(true);
        }
    });

    this.options = options;
    this.$dialog = $dialog;
    this.callbackList = buttons.map(data => data.callback);

    this.show();
}

Dialog.prototype = {
    show() {
        var $dialog = this.$dialog;

        $dialog.style.display = '';
        $dialog.clientHeight;
        $dialog.classList.remove('cp-dialog-wrap--close');
    },
    del(emitCallback) {
        this.close(true, emitCallback);
    },
    close(del, emitCallback) {
        var $dialog = this.$dialog;
        var onClose = this.options.onClose;

        // 防止多次调用close
        if (!$dialog) return;

        if (!emitCallback || (onClose && onClose(this, del) !== false)) {
            $dialog.classList.add('cp-dialog-wrap--close');
            del && delete this.$dialog;

            setTimeout(function () {
                if (!$dialog.parentNode) return;

                if (del) {
                    $dialog.parentNode.removeChild($dialog);
                    $dialog.removeEventListener('click', this._handler);
                } else {
                    $dialog.style.display = 'none'
                }
            }, 300);
        }
    }
}


/**
 * 创建一个模态框
 * @param  {Object}  options
 * @param  {String}  options.context       模态框的内容
 * @param  {Boolean} options.useCloseBtn   模态框的右上角关闭按钮
 * @param  {Boolean} options.backdropClose 模态框的背景是否可以关闭
 * @param  {Boolean} options.onClose     模态框的关闭回调函数
 * @param  {Array}   options.button      模态框的按钮
 * @param  {String}           options.button[].text       模态框的按钮文本
 * @param  {String|Function}  options.button[].callback   模态框的按钮回调
 *
 * @example
 * dialog('确定要删除？', [
 *   {text: '是', callback: function() {
 *       ajaxDel().then(() => this.del())
 *   }},
 *   {text: '否', callback: 'del'}
 * ])
 */
export default function dialog(options) {
    return new Dialog(options);
}

dialog.promise = function(text, fn) {
    var dialog;
    var pr = new Promise(function(resolve, reject) {
        dialog = dialog({
            title:title,
            content: text,
            button: fn(resolve, reject)
        });
    });

    pr.dialog = dialog;

    return pr;
}



// WEBPACK FOOTER //
// ./src/lib/dialog.js